import image1 from '../assets/testimonials/skyford_testimonial_shifa.jpg'; 
import image2 from '../assets/testimonials/skyford_testimonial_rinciya.jpg'; 
import image3 from '../assets/testimonials/skyford_testimonial_rizwan.jpg'; 
import image4 from '../assets/testimonials/skyford_testimonial_chandana.jpg'; 
import image5 from '../assets/testimonials/skyford_testimonial_safeedha.jpg'; 
import image6 from '../assets/testimonials/skyford_testimonial_shibil.jpg'; 

const testimonialData = [
  {
    id: 1,
    name: "Shifa",
    role: "Aroon Aviation Services Pvt. Ltd.",
    image: image1,
    feedback: "Training at Skyford Aviation was truly life-changing. The hands-on experience and industry-focused lessons helped me land my dream job.",
    rating: 5
  },
  {
    id: 2,
    name: "Rinciya",
    role: "Air India Sats",
    image: image2,
    feedback: "The aviation and AI program gave me a unique edge in the industry. Combining traditional aviation skills with modern technology was truly invaluable.",
    rating: 5
  },
  {
    id: 3,
    name: "Rizwan",
    role: "Aroon Aviation Services Pvt. Ltd.",
    image: image3,
    feedback: "Excellent training with top-notch facilities. The mentors, who are industry experts, gave me valuable guidance for my career.",
    rating: 5
  },
  {
    id: 4,
    name: "Chandana",
    role: "Gia Travel",
    image: image4,
    feedback: "The detailed curriculum and practical training sessions prepared me effectively for real-world challenges in the industry.",
    rating: 5
  },
  {
    id: 5,
    name: "Safeedha",
    role: "Aroon Aviation Services Pvt. Ltd.",
    image: image5,
    feedback: "Skyford provided me with the skills and confidence to succeed. The training is excellent, and the support is outstanding!",
    rating: 5
  },
  {
    id: 6,
    name: "Shibil",
    role: "AirAsia X",
    image: image6,
    feedback: "An excellent academy with great instructors and facilities. It prepared me perfectly for the aviation industry.",
    rating: 5
  },
];

export default testimonialData;